import { createContext, useContext } from 'react'

export type ICheckboxContext = [string[], (field: string, checked: boolean) => void];

export const CheckboxContext = createContext<ICheckboxContext>([[], () => {}]);

export const useCheckbox = () => useContext(CheckboxContext);